export interface ShortcutGroup {
  title: string
  shortcuts: Array<{
    keys: string[]
    description: string
    isSimultaneous?: boolean
    route?: string
  }>
}

// Single source of truth for all keyboard shortcuts
export const navigationShortcuts = [
  { keys: ['g', 'h'], description: 'Home', route: '/home' },
  {
    keys: ['g', 's'],
    description: 'Schedules',
    route: '/billing-schedules'
  },
  { keys: ['g', 'c'], description: 'Customers', route: '/customers' },
  {
    keys: ['g', 'i'],
    description: 'Invoices',
    route: '/invoices?sortBy=accountingDate_desc'
  },
  {
    keys: ['g', 'x'],
    description: 'Credit notes',
    route: '/credit-notes'
  },
  { keys: ['g', 'q'], description: 'Quotes', route: '/quotes' },
  { keys: ['g', 'p'], description: 'Products', route: '/products' },
  {
    keys: ['g', 'u'],
    description: 'Usage events',
    route: '/usage-events'
  },
  {
    keys: ['g', 'm'],
    description: 'Usage metrics',
    route: '/usage-metrics'
  },
  {
    keys: ['g', 'e'],
    description: 'Seats events',
    route: '/seat-events'
  },
  {
    keys: ['g', 'b'],
    description: 'Seats balances',
    route: '/seat-balances'
  },
  { keys: ['g', 't'], description: 'Seats metrics', route: '/seats' },
  {
    keys: ['g', 'r'],
    description: 'Revenue recognition',
    route: '/revenue-recognition'
  },
  {
    keys: ['g', 'd'],
    description: 'Deferred revenue',
    route: '/revenue-recognition/deferred-revenue'
  },
  { keys: ['g', 'v'], description: 'Insights', route: '/insights' },
  { keys: ['g', 'w'], description: 'Watchtower', route: '/watchtower' },
  { keys: ['g', 'w', 'w'], description: 'Workflows', route: '/workflows' }
]

// Navigation UI shortcuts
export const navigationUIShortcuts = [
  { keys: ['['], description: 'Collapse navigation sidebar' },
  { keys: [']'], description: 'Expand navigation sidebar' }
]

// MagicTable shortcuts — open filter / view-settings menus on the
// current table. `target` names the toolbar button the sequence
// clicks via a `data-keyboard-shortcut-target` attribute on the
// element. Using a dedicated attribute (rather than reusing
// data-testid) keeps shortcut wiring distinct from test selectors —
// either can change without breaking the other. The binding lives in
// useKeyboardNavigation.
export const magicTableShortcuts = [
  {
    keys: ['t', 'f'],
    description: 'Open filter menu',
    target: 'magicTable.filters'
  },
  {
    keys: ['t', 'v'],
    description: 'Open view settings menu',
    target: 'magicTable.viewSettings'
  },
  {
    keys: ['t', 'c'],
    description: 'Add column',
    target: 'magicTable.addColumn'
  }
]

export const leftColumnGroups: ShortcutGroup[] = [
  {
    title: 'General',
    shortcuts: [
      {
        keys: ['⌘', '/'],
        description: 'View keyboard shortcuts',
        isSimultaneous: true
      }
    ]
  },
  {
    title: 'Go to...',
    shortcuts: navigationShortcuts
  },
  {
    title: 'Navigation',
    shortcuts: navigationUIShortcuts
  }
]

// Invoice creation shortcuts
export const invoiceCreationShortcuts = [
  { keys: ['⌘', '['], description: 'Previous step', isSimultaneous: true },
  { keys: ['⌘', ']'], description: 'Next step', isSimultaneous: true },
  { keys: ['⌘', 'Enter'], description: 'Send invoice', isSimultaneous: true }
]

export const rightColumnGroups: ShortcutGroup[] = [
  {
    title: 'Tables',
    shortcuts: magicTableShortcuts
  },
  {
    title: 'Invoice Creation',
    shortcuts: invoiceCreationShortcuts
  }
]
